import { Routes } from '@angular/router';
import { AppUrls } from '../../../common/dto/app-urls';
import { AuthRoutes } from './auth/auth.routes';
import { CompanyRoute } from './company/company.routes';
import { DashboardRoute } from './dashboard/dashboard.routes';

export const routes: Routes = [
  DashboardRoute,
  CompanyRoute,
  ...AuthRoutes,
  {
    path: AppUrls.NotFound.relativeUrl,
    loadComponent: () => import('./common/components/not-found/not-found.component').then(_ => _.NotFoundComponent),
  },
  {
    path: '**',
    redirectTo: AppUrls.Dashboard.absoluteUrl,
  },
];
